<template>
  <b-row class="justify-content-center" no-gutters>
    <b-col cols="12" sm="8" md="6" lg="4" xl="4" class="fit-to-screen bg-white text-center pt-5">
      <img class="my-4" src="../../assets/img/ilustration/integrated.png" height="300">
      <p class="mb-3 heading-5-2">Congratulations!</p>
      <p class="mb-0 mx-auto body-1 w-75">
        Your data has been successfully connected to your GetPlus account. Please contact our staff for further
        information.
      </p>
    </b-col>
  </b-row>
</template>

<script>
  import GPLogo from '../../assets/img/brand/guestpro.png'

  export default {
    metaInfo(){
			var return_data = {
				title: 'Succesfully connected',
        link: [
          { rel: 'shortcut icon', href: GPLogo}
        ]
			}	
    	return return_data
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/general/Integration.vue